/** Retail premium proposal tab model — mirrors projector tab structure. */

export type RetailPremiumTabId = "clarity" | "solution" | "terms";

export type RetailPremiumTabItem = {
  id: RetailPremiumTabId;
  label: string;
};

export type PdfWrapperPremiumTabId = "clarity" | "proposal" | "terms";

export type PdfWrapperPremiumTabItem = {
  id: PdfWrapperPremiumTabId;
  label: string;
};

export function resolveRetailProposalTitle(input: {
  proposalName?: string | null;
  proposalRef?: string | null;
}): string {
  const name = String(input.proposalName ?? "").trim();
  if (name) return name;
  const ref = String(input.proposalRef ?? "").trim();
  return ref || "Your Solution";
}

export function buildRetailPremiumTabItems(proposalTitle: string): RetailPremiumTabItem[] {
  const solutionLabel = proposalTitle.trim() || "Your Solution";
  return [
    { id: "clarity", label: "Clarity" },
    { id: "solution", label: solutionLabel },
    { id: "terms", label: "Terms and Conditions" },
  ];
}

export function buildPdfWrapperPremiumTabItems(proposalTitle: string): PdfWrapperPremiumTabItem[] {
  const proposalLabel = proposalTitle.trim() || "Your Proposal";
  return [
    { id: "clarity", label: "Clarity" },
    { id: "proposal", label: proposalLabel },
    { id: "terms", label: "Terms and Conditions" },
  ];
}

export const RETAIL_WHY_WE_RECOMMEND_COPY =
  "Every item in this proposal is selected for how it performs in your space — compatibility, reliability, and the experience you can expect day to day. We specify complete solutions, not isolated parts, so you can proceed with confidence.";
